<!-- <div id="appHeader">
  <nav
    class="navbar navbar-expand-lg navbar-dark navbar-absolute px-lg-3 px-md-3 px-sm-3"
  >
    <a class="navbar-brand " routerLink="/">
      <img
        src="./assets/img/logo_small.png"
        class="d-inline-block align-middle img-fluid w-25 ms-4 me-2"
        alt="brand_logo"
      />
      TILA Top up
    </a>
  </nav>
</div> -->
<app-header [showTopbar]="false"></app-header>
<div class="container-fluid">
  <div class="session-activity-container">
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-6 col-md-5 col-sm-4 col-xs-12 align-self-center">
        <div class="login-blk">
          <mat-card class="p-4 text-center">
            <h4 class="form-title text-center my-4" translate>
              pages.login.verification
            </h4>
            <h4 class="text-center fs-4" translate>pages.login.welcometo</h4>
            <h4 class="my-3 fs-4">TILA TOP UP</h4>
            <p class="form-field-tile mx-5 text-center" translate>
              pages.login.codesenttoMobile
              <span> {{ notificationMethod }}</span> <br />
            </p>
            <p class="mt-1 mb-3">{{ notifyBy }}</p>
            <ng-pass-otp
              class="otp-input text-center"
              (onInputChange)="onOtpChange($event)"
              (keydown.enter)="submit()"
              [config]="config"
            ></ng-pass-otp>
            <mat-card-subtitle class="text-center mt-4"
              ><span translate
                >pages.login.didntgetyourcodeyet</span
              ></mat-card-subtitle
            >
            <a
              class="cur-point border-underline text-main"
              (click)="onReSenedCode()"
              ><span translate>pages.login.resendCode</span></a
            >
            <button
              mat-raised-button
              (click)="submit()"
              [disabled]="!canSubmit"
              color="primary"
              type="submit"
              class="d-block mx-auto my-4 py-2 w-100 margintop2"
            >
              <span translate class="translate">pages.login.verify</span>
            </button>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
